import axios from 'axios';

export const authAxios = axios.create({ baseURL: process.env.AUTH_URL, withCredentials: true });

// Add a request interceptor to include the account type in the headers
authAxios.interceptors.request.use((config: any) => {
  config.headers['X-Account-Type'] = 'agency';
  return config;
}, (error) => {
  return Promise.reject(error);
});